<template>
  <div id="index">
    <mHeader ref="mHeader"></mHeader> 
    <div style="width:100%;height:44px"></div>
    <div class="mProductDetails" :class="morenDiv == false ? 'none':''">
     <div class="mProductDetailsBox">
        <h3><img src="../../assets/img/productDetailsIcon.png" alt=""> {{goodsDetails.companyName}}</h3>
        <div class="mProductDetailsBox1">
          <img :src="goodsDetails.images" class="mProductDetailsImg">
          <ul>
            <li>商品名称：<b>{{goodsDetails.goodName}}</b></li>
            <!-- <li><h6> <a>价格电议</a> </h6></li> -->
            <li><p>产　　地：{{goodsDetails.chandi}}</p></li>
            <li><p>规格等级： {{goodsDetails.skuName}} </p> </li>
            <li><p>产区：<b>{{goodsDetails.chanqu}}</b></p></li>
            <li><p>存　　量：<b>9999千克</b></p></li>
            <li><p>质量要求：{{goodsDetails.content}} </p></li>
            <li><p>联系方式：{{goodsDetails.phone}}</p></li>
          </ul>
        </div>
      </div>
    </div>
    <h2 class="mProductDetailsTitle">推荐产品</h2>
    <ul class="mIndexPro">
      <li v-for="item in othersList.slice(0,4)" :key="item.id"  @click="goProductDetails(item.id)">
        <img :src="item.goodsImage" />
        <p>{{item.goodName}}&nbsp;{{item.chandi}}</p>
        <p><span>价格电议</span> </p>
      </li>
    </ul>
  </div>
</template>
<script>
import mHeader from '../../components/mobile/mHeader'
export default {
  components: {
    mHeader
  },
  data() {
    return {
      phoneDialog:false,
      phone:'',
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
      productDetailsImg:require('../../assets/img/productDetailsIconImg.png'),
      productImgList:[
        {id:"001",imgUrl:require('../../assets/img/productDetailsImg1.png')},
        {id:"002",imgUrl:require('../../assets/img/productDetailsImg2.png')},
        {id:"003",imgUrl:require('../../assets/img/productDetailsImg3.png')},
        {id:"003",imgUrl:require('../../assets/img/productDetailsImg4.png')},
        {id:"003",imgUrl:require('../../assets/img/productDetailsImg5.png')}
      ],
      goodsDetails:{},
      othersList:[],
      goodsShowIndex:-1
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getProductDetails();
    this.getOtherList();
  },
  methods: {
    getProductDetails(){
      this.goodsDetails = {}
      this.$fetch('getGoodsDetails',{id:this.$route.query.id}).then(res => {
       this.goodsDetails = res.result;
      })
    },
    getOtherList(){
      this.$fetch('getOtherList').then(res => {
       this.othersList = res.result;
      })
    },
    goProductDetails(id){
      this.$router.push({name:'mProductDetails',query: {id:id}})
      this.getProductDetails()
    },
    changeImg(data){
      this.goodsDetails.images = data.image;
    },
    showPhone(index){
      this.goodsShowIndex = index;
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/mobile/mProductDetails.vue